export const getSentenceWords = (sentence: string) => {
  try {
    const words = sentence.trim().split(/\s+/);

    // Return the number of words
    return words.length;
    // eslint-disable-next-line no-empty
  } catch {}
};
